import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { Loader } from "components/common/Icons/Loader/Loader";
import { useCropPreview } from "./useCropPreview";

export const CropPreview = () => {
    const { previewContainerRef, parentImageRef, cropRef, isLoading, initialImageRef, downloaded } = useCropPreview();

    return (
        <div className="relative overflow-hidden h-full w-full">
            <div
                className="absolute inset-0 h-2/3 lg:h-full overflow-hidden mx-auto flex items-start lg:items-center justify-center"
                ref={previewContainerRef}
            >
                <div className="inline-block">
                    <img ref={parentImageRef} className="hidden" />
                    <img ref={initialImageRef} className="hidden" />
                    <img ref={cropRef} className={`${isLoading ? "hidden" : ""}`} data-testid="crop-preview" />
                </div>
                {isLoading && (
                    <div className="flex flex-col gap-4 items-center">
                        <Loader className="stroke-[var(--dark-gray)]" height={35} width={35} />
                        <div className="font-semibold dark:text-white">{`${downloaded} ${capitalize(
                            translateFunc("downloaded"),
                        )}`}</div>
                    </div>
                )}
            </div>
        </div>
    );
};
